import footerLogo from '../assets/images/footer-logo.png';
import facebookIcon from '../assets/icons/facebook.png';
import instagramIcon from '../assets/icons/instagram.png';
import twitterIcon from '../assets/icons/twitter.png';
import linkedinIcon from '../assets/icons/linkedin.png';

const socialLinks = [
  { key: 'facebook', label: 'Facebook', icon: facebookIcon },
  { key: 'instagram', label: 'Instagram', icon: instagramIcon },
  { key: 'x', label: 'X', icon: twitterIcon },
  { key: 'linkedin', label: 'LinkedIn', icon: linkedinIcon }
];

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-brand">
          <img src={footerLogo} alt="Dream Home logo" />
          <div className="footer-brand-text">
            <p className="footer-name">Dream Home</p>
            <div className="footer-contact">
              <span className="footer-contact-label">Headquarter</span>
              <span className="footer-contact-phone">+961 70 202030</span>
            </div>
          </div>
        </div>
        <h2 className="footer-tagline">Home is the story of who we are</h2>
      </div>

      <div className="footer-bottom">
        <p className="footer-copy">© 2025 Developed by mindlares.com, all rights reserved.</p>
        <div className="footer-social">
        {/*   {socialLinks.map((item) => (
            <button key={item.key} aria-label={item.label} className="social-link">
              <img src={item.icon} alt="" />
            </button>
          ))} */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
